import { Quote } from "lucide-react";

const TESTIMONIALS = [
  {
    quote:
      "Our Claude Code bill dropped by a third in the first week and nobody changed how they work. The recovery layer means we never lost a file the agent actually needed.",
    name: "Priya Natarajan",
    role: "Staff Engineer, Hexabase",
    initials: "PN",
    testid: "testimonial-card-1",
  },
  {
    quote:
      "I was skeptical about lossless compression claims, so I diffed every recall for a month. Zero misses. It is now part of our default dev setup.",
    name: "Marcus Feld",
    role: "Platform Lead, Kernelhub",
    initials: "MF",
    testid: "testimonial-card-2",
  },
  {
    quote:
      "The analytics alone justified it. We finally see which repos burn tokens and autopilot keeps opening PRs that shave more off. It pays for itself.",
    name: "Sofia Reyes",
    role: "Engineering Manager, Stackforge",
    initials: "SR",
    testid: "testimonial-card-3",
  },
];

export const Testimonials = () => {
  return (
    <section
      data-testid="testimonials-section"
      className="max-w-6xl mx-auto px-6 py-24 border-b border-seam"
    >
      <div className="mb-12">
        <span className="text-xs font-semibold uppercase tracking-widest text-ember">
          From The Community
        </span>
        <h2 className="font-serif text-3xl sm:text-4xl text-white mt-1">
          Developers keep the fire, ditch the burn
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {TESTIMONIALS.map((t) => (
          <figure
            key={t.name}
            data-testid={t.testid}
            className="rounded-xl border border-seam bg-coal p-6 flex flex-col justify-between hover:border-ember/50 transition-colors"
          >
            <div>
              <Quote className="w-5 h-5 text-ember mb-4" />
              <blockquote className="text-sm text-ash leading-relaxed mb-6">
                &ldquo;{t.quote}&rdquo;
              </blockquote>
            </div>
            <figcaption className="flex items-center gap-3 pt-4 border-t border-seam">
              <span className="w-9 h-9 rounded-full bg-ember/15 border border-ember/30 text-ember text-xs font-bold flex items-center justify-center">
                {t.initials}
              </span>
              <span>
                <span className="block text-sm font-semibold text-white">
                  {t.name}
                </span>
                <span className="block text-[11px] text-smoke">{t.role}</span>
              </span>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
};
